'use strict';

DoohApps.factory('treeControlHelper', ['modal2', function (modal2) {
    return {
        openTreeControl : function (callback, currentPath, companyID) {
            var modalObj = {
                name: 'MediaAssetFolderTree',
                windowClass: 'treeControlModal',
                backdrop: 'static',
                resolvedCallback: function (data) {
                    //returns data.path and data.folder
                    if (callback != null)
                        callback(data);
                },
                passObj: { path: currentPath, companyID: companyID }
            }
            modal2.open(modalObj);
        }
    }
}]);